import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Endpoint } from '@enums/endpoint.enum';
import { StorageHelper } from '@helpers/storage.helper';
import { AuthResponse } from '@models/auth-response.model';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private http: HttpClient) { }

  authenticate(email: string, password: string): Observable<boolean> {
    const url = `${environment.apiBaseUrl}${Endpoint.TOKEN}`;

    return this.http.get(url, { headers: { Authorization: 'Basic ' + btoa(`${email}:${password}`) } }).pipe(
      map((response: any) => {
        if (!response.data) {
          return false;
        }

        this.setAccessToken(new AuthResponse({...response.data, timestamp: Date.now()}));

        return true;
      })
    );
  }

  logout(): Observable<boolean> {

    const url = `${environment.apiBaseUrl}/${Endpoint.REVOKE_TOKEN}`;

    return this.http.delete(url).pipe(
      map((response: any) => {
        this.removeAccessToken();

        return true;
      }),
      catchError(error => {
        return of(false);
      })
    );
  }

  refreshToken(): Observable<boolean> {
    const url = `${environment.apiBaseUrl}/${Endpoint.REFRESH_TOKEN}`;
    const token = this.getAccessToken();

    return this.http.get(url, { headers: { Authorization: `Bearer ${token?.jwt}` } }).pipe(
      map((response: any) => {
        this.setAccessToken(new AuthResponse({...response.data, timestamp: Date.now()}));
        return true;
      })
    );
  }

  isAuthenticated(): boolean {
    const token = this.getAccessToken();

    return !!token?.jwt && !token?.isExpired();
  }

  getAccessToken() {
    return StorageHelper.getToken() || new AuthResponse();
  }

  removeAccessToken() {
    StorageHelper.removeToken();
  }

  setAccessToken(auth: AuthResponse) {
    StorageHelper.setToken(auth);
  }
}
